<template>
    <div class="page">
        <section class="row content">
            <div class="wrapper partner-list">
                <div class="partner-list__navigation">
                    <back-button class="partner-list__back-button"
                        :isBlack="true"
                    />
                    <header class="row__header">
                        <h1>
                            {{ sportName }}
                        </h1>
                    </header>
                </div>
                <router-link v-for="(partner, index) in partners"
                    :key="index"
                    :to="`/partner/${partner.id}`"
                >
                    <partner-tile :partner="partner" />
                </router-link>
            </div>
        </section>
    </div>
</template>

<script>
// 3rd party libs
import {
    mapGetters,
} from 'vuex';

// Components
import partnerTile from '@webapp/components/partner-tile/partner-tile.vue';
import backButton from '@webapp/components/back-button/back-button.vue';

export default {
    name: 'partner-list',
    components: {
        partnerTile,
        backButton,
    },
    computed: {
        ...mapGetters(['sportsById', 'getTranslatedStr']),
        ...mapGetters('partners', ['partnersBySport']),

        sportId() {
            return this.$route.params.id || '';
        },
        sportName() {
            if (this.sportId) {
                const sport = this.sportsById(this.sportId);
                const name = this.getTranslatedStr(sport, 'name', sport.name);

                document.title = `${name} | Category | Socios.com`;

                return name;
            }

            return '';
        },
        partners() {
            return this.partnersBySport(this.sportId) || '';
        },
    },
};
</script>

<style lang="scss" scoped>
.row {
    background: linear-gradient($ghost-white-color 0%, rgb($dusty-gray-color, 0.1) 100%);

    @include min-width(md) {
        padding: 2rem 5rem;
    }
}

.content {
    flex: 1;
}

.partner-list {
    > a {
        text-decoration: none;
    }

    &__title {
        color: $blue-charcoal-color;
        font-size: 2.5rem;
        font-weight: 600;
    }

    &__back-button {
        top: 0;
        position: unset;
    }

    &__navigation {
        display: flex;
        align-items: center;
        margin: 0 0 1rem 0;
    }
}
</style>